import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '@/shared/utils'
type Props = {
  className?: string
  path: string
  svgClassName?: string
}
const CustomSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px'}) => {
  return (
    <span className={`svg-icon ${className}`}>
      {<SVG src={toAbsoluteUrl(path)} className={svgClassName} />}
    </span>
  )
}

export {CustomSVG}
